import { useCallback } from "react";

import { type FetchResult, useMutation } from "@apollo/client";

import { type Visibility } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type SetVisibilityMutation, type SetVisibilityMutationVariables, setVisibilityData } from "../api/mutations";
import { getLensDestinations, getLensInfo } from "../api/queries";

export const useSetVisibility = (
    lensId: string,
    lensFolderId: string,
): ApolloResult<{
    setVisibility: (visibility: Visibility) => Promise<FetchResult<SetVisibilityMutation>>;
}> => {
    const [setVisibilityInfo, { loading, error }] = useMutation<SetVisibilityMutation, SetVisibilityMutationVariables>(
        setVisibilityData,
        {
            refetchQueries: [
                { query: getLensDestinations, variables: { lensId, lensFolderId } },
                { query: getLensInfo, variables: { lensId } },
            ],
        },
    );

    const setVisibility = useCallback(
        (visibility: Visibility) =>
            setVisibilityInfo({
                variables: {
                    lensId,
                    visibility,
                },
            }),
        [lensId, setVisibilityInfo],
    );

    return { setVisibility, loading, error };
};
